'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
    [
      "\n  @font-face {\n    font-family: Averta;\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(//hackclub.com/fonts/averta-regular.woff2) format('woff2'),\n      url(//hackclub.com/fonts/averta-regular.woff) format('woff');\n    unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n  }\n  @font-face {\n    font-family: Averta;\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(//hackclub.com/fonts/averta-bold.woff2) format('woff2'),\n      url(//hackclub.com/fonts/averta-bold.woff) format('woff');\n    unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n  }\n"
    ],
    [
      "\n  @font-face {\n    font-family: Averta;\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(//hackclub.com/fonts/averta-regular.woff2) format('woff2'),\n      url(//hackclub.com/fonts/averta-regular.woff) format('woff');\n    unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n  }\n  @font-face {\n    font-family: Averta;\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(//hackclub.com/fonts/averta-bold.woff2) format('woff2'),\n      url(//hackclub.com/fonts/averta-bold.woff) format('woff');\n    unicode-range: U + 0000 - F8FE, U + F900-FFFF;\n  }\n"
    ]
  ),
  _templateObject2 = _taggedTemplateLiteral(
    [
      '\n* {\n  box-sizing: border-box;\n  font-weight: inherit;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\nhtml,\nbody {\n  min-height: 100%;\n  min-width: 100%;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-size: ',
      'px;\n  font-family: ',
      ';\n  line-height: 1.5;\n  position: relative;\n  height: 100%;\n  max-height: 100%;\n  width: 100vw;\n  -webkit-font-smoothing: antialiased;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\na {\n  color: currentColor;\n  text-decoration: none;\n}\n\ntextarea {\n  resize: none;\n}\n'
    ],
    [
      '\n* {\n  box-sizing: border-box;\n  font-weight: inherit;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\nhtml,\nbody {\n  min-height: 100%;\n  min-width: 100%;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-size: ',
      'px;\n  font-family: ',
      ';\n  line-height: 1.5;\n  position: relative;\n  height: 100%;\n  max-height: 100%;\n  width: 100vw;\n  -webkit-font-smoothing: antialiased;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\na {\n  color: currentColor;\n  text-decoration: none;\n}\n\ntextarea {\n  resize: none;\n}\n'
    ]
  )

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _styledComponents = require('styled-components')

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _objectWithoutProperties(obj, keys) {
  var target = {}
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
    target[i] = obj[i]
  }
  return target
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var fontsCss = (0, _styledComponents.css)(_templateObject)

;(0, _styledComponents.injectGlobal)(
  _templateObject2,
  _theme2.default.fontSizes[2],
  _theme2.default.font
)

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
    webfonts = _ref.webfonts,
    props = _objectWithoutProperties(_ref, ['theme', 'webfonts'])

  if (webfonts) (0, _styledComponents.injectGlobal)([], fontsCss)
  return _react2.default.createElement(
    _styledComponents.ThemeProvider,
    _extends(
      {
        theme: theme
      },
      props,
      {
        children: _react2.default.createElement(
          _react.Fragment,
          null,
          props.children
        )
      }
    )
  )
}

ThemeProvider.propTypes = {
  theme: _propTypes2.default.object,
  webfonts: _propTypes2.default.bool
}

ThemeProvider.defaultProps = {
  theme: _theme2.default,
  webfonts: false
}

exports.default = ThemeProvider



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/ThemeProvider.js
// module id = 522
// module chunks = 168707334958949